module.exports = __webpack_public_path__ + "static/media/wijn-rose-fles.daef099d.png";